<section class="add-admission-location">
  <h2><span style="vertical-align: sub;">Add Admission Ward Location</span> <button mat-stroked-button class="ms-12"
      style="padding: 4px !important; padding-left: 12px !important; padding-right: 12px !important;
    ">
      <mat-icon>add</mat-icon>
      Add Other Locations

    </button></h2>
  <!--Add other types of Location button-->
  <p>Define reusable location metadata (wards, rooms, beds, etc.).</p>

  <!--Section for SameAddress?-->
  <div class="py-15">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Same As Hospital / Organization Address?</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-slide-toggle [formControl]="addressSameAsHospital" class="me-15">
          <span class="ms-8">
            Is this Admission Ward located at the same address as the Hospital/Organization?

          </span>
        </mat-slide-toggle>
      </mat-card-content>
    </mat-card>

  </div>

  <!--Section for parent location-->
  <div class="py-15">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Parent Location</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="g-just-flex"
          style="justify-content: flex-start; flex-wrap: wrap; gap: 20px; width: 650px; max-width: 100%; box-sizing: border-box;">
          @if(locationTypeSlice){
          <div style="flex: 1 1 100%;">
            <app-dynamic-forms-v2 [formFields]="locationTypeSlice ? [locationTypeSlice] : []" [formMetaData]="{formName: 'Where is the Ward Located? (Type)', formDescription: `
          In which type of location or area is this Admission Ward located?
          `, showSubmitButton: false}" #partOfTypeFormRef
              (onEveryChange)="onPartOfTypeChange($event)"></app-dynamic-forms-v2>
          </div>
          }
          @if(partOfType.value){
          @if(partOfType.value && parentLocationSlice && parentLocationSlice.data && parentLocationSlice.data.length >
          0 && prefersExistingParentLocation){
          <div style="flex: 1 1 100%;">
            <app-dynamic-forms-v2 #parentLocationFormRef [formFields]="parentLocationSlice ? [parentLocationSlice] : []"
              [formMetaData]="{formName: 'Where is the Ward Located? (Exact Location)', formDescription: `
          Select the exact building or area where this Admission Ward is located.
          `, showSubmitButton: false}" (onEveryChange)="onParentLocationChange($event)"></app-dynamic-forms-v2>
            <div class="py-12">

              <button mat-flat-button>
                <mat-icon>swap_horiz</mat-icon>
                <span (click)="prefersExistingParentLocation = false; existingParentLocationReference = undefined">Enter
                  New
                  Parent Location Name</span>
              </button>
            </div>

          </div>
          }@else {
          <div style="flex: 1 1 100%;">

            <app-dynamic-forms-v2 #newParentLocationFormRef [formFields]="newParentLocationNameForm"
              [formMetaData]="{formName: 'Where is the Ward Located? (Name)', formDescription:partOfType.value?.display && !parentLocationSlice?.data?.length? `
            There is currently no registered `+(partOfType.value?.display || '')+` in the system.
              Please, enter the name of the `+(partOfType.value?.display || '')+` where this Admission Ward is located.
          `:' Please, enter the name of the new '+partOfType.value?.display+' Parent location', showSubmitButton: false}" (onEveryChange)="onNewParentLocationNameChange($event)"></app-dynamic-forms-v2>
            @if(parentLocationSlice?.data?.length){
            <div class="py-12">

              <button mat-flat-button>
                <mat-icon>swap_horiz</mat-icon>
                <span
                  (click)="prefersExistingParentLocation = true; newParentLocationResourceRawValues = undefined">Select
                  Existing Parent Location</span>
              </button>
            </div>
            }


          </div>
          }
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <mat-card>
    <mat-card-header></mat-card-header>
    <ng-container *ngIf="!loading; else loadingState">
      @if(generalFormSlice){
      <div style="width:650px; max-width: 100%;">
        <app-dynamic-forms-v2 (onEveryChange)="onGeneralLocationFormChange($event)" #generalLocationForm
          [formMetaData]="formMetaData" [formFields]="generalFormSlice">
        </app-dynamic-forms-v2>
      </div>
      }
    </ng-container>
    <!-- {{wardLocation | json}} -->

  </mat-card>

  <!--Section for rooms and beds-->
  <div class="py-15">
    <mat-card>
      <mat-card-header>
        <!-- <mat-card-title>Rooms and Beds</mat-card-title>
        <mat-card-subtitle>Define rooms and beds within this Admission Ward location.</mat-card-subtitle> -->
      </mat-card-header>
      <mat-card-content>
        <div style="width: 650px; max-width: 100%;">


          <app-dynamic-forms-v2 [formMetaData]="RoomsAndBedsMetaData" [formFields]="RoomsAndBedsFormFields"
            (onEveryChange)="onRoomsAndBedsFormChange($event)" #roomsAndBedsFormRef>

          </app-dynamic-forms-v2>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <ng-template #loadingState>
    <p>Loading location fields…</p>
  </ng-template>

  <div class="g-just-flex justify-content-end mt-20">
    <button mat-flat-button (click)="onSubmitAdmissionLocation()" [disabled]="submitting">
      <mat-icon>check</mat-icon>
      <span *ngIf="!submitting">Submit Admission Location</span>
      <span *ngIf="submitting">Submitting...</span>
    </button>
  </div>
</section>